import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login'
import PaymentOne from '../views/PaymentOne'
import PaymentTwo from '../views/PaymentTwo'
import XmlMessage from '../views/XmlMessage'
import PaymentThree from '../views/PaymentThree'
import ReturnToFpx from '../views/ReturnToFpx'
import RequestFromFpx from '../views/RequestFromFpx'
import PayErrorPage from '../views/PayErrorPage'
import SysError from '../views/SysError'
import NotFound from '../views/NotFound'
import TokenError from '../views/TokenError'
Vue.use(Router)
export default new Router({

  routes: [
    {
      path: '/login',
      name: 'Login',
      meta: { title: 'Login' },
      component: Login
    },
    {
      path: '/paymentOne',
      name: 'PaymentOne',
      component: PaymentOne
    },
    {
      path: '/successful',
      name: 'PaymentThree',
      component: PaymentThree
    },
    {
      path: '/paymentTwo',
      name: 'PaymentTwo',
      component: PaymentTwo
    },
    {
      path: '/xml',
      name: 'XmlMessage',
      component: XmlMessage
    },
    {
      path: '/returnToFpx',
      name: 'ReturnToFpx',
      component: ReturnToFpx
    },
    {
      path: '/requestFromFpx',
      name: 'RequestFromFpx',
      component: RequestFromFpx
    },
    {
      path: '/unsuccessful',
      name: 'PayErrorPage',
      component: PayErrorPage
    },
    {
      path: '/error',
      name: 'SysError',
      component: SysError
    },

    {
      path: '/notFound',
      name: '/NotFound',
      component: NotFound
    },

    {
      path: '/tokenError',
      name: 'TokenError',
      component: TokenError
    },

    // {
    //   path: '/',
    //   redirect: '/xml',
    //   keepAlive: false
    // },

    {
      path: '/',
      redirect:'/notFound',
      keepAlive: false
    },

  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js